// The ONE table date cell: compact date-only, muted so data columns lead, full
// timestamp on hover via `title`. Detail surfaces (KeyValue rows, the audit
// log's forensic Time column) keep the full `formatDateTime` rendering
// instead.
import { formatDate, formatDateTime, formatMonthDay } from "../../lib/format";
import { Text } from "../../ui";

export function DateCell({
  value,
  showYear = true,
}: {
  value: string | null | undefined;
  showYear?: boolean;
}) {
  if (!value) {
    return (
      <Text as="span" variant="muted">
        -
      </Text>
    );
  }
  return (
    <Text as="span" title={formatDateTime(value)} variant="muted">
      {showYear ? formatDate(value) : formatMonthDay(value)}
    </Text>
  );
}
